import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import paths from '../../router/RoutePaths';

export default function SpaceWrapper() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === '/space' || location.pathname === '/space/') {
      navigate(paths.Home);
    }
  }, []);

  return <Outlet />;
}
